const portraitImg = new URL(
  "../assets/img/orientation/portrait.webp",
  import.meta.url,
).href;
const landscapeImg = new URL(
  "../assets/img/orientation/landscape.webp",
  import.meta.url,
).href;
const cardWidth = "22%";

class OrientationSelector extends HTMLElement {
  state = {
    printType: "paper",
    posterOrientation: "portrait",
  };

  disabledByPrintType = {
    acryl: [],
    aluminium: [],
    tegel: ["landscape"],
  };

  connectedCallback() {
    this.render();
    this.bindEvents();
    this.applyAll();
  }

  setState(next = {}) {
    this.state = { ...this.state, ...next };
    this.applyAll();
  }

  bindEvents() {
    this.addEventListener("click", (e) => {
      const el = e.target.closest(".js-poster-orientation");
      if (!el || !this.contains(el)) return;

      const posterOrientation = String(el.dataset.posterOrientation);

      // als hij verborgen is: negeer klik
      if (el.classList.contains("d-none")) return;

      this.setState({ posterOrientation });

      // laat main.js weten dat er gekozen is
      this.dispatchEvent(
        new CustomEvent("orientation-change", {
          detail: { posterOrientation },
          bubbles: true,
        }),
      );
    });
  }

  applyAll() {
    this.applyAvailability();
    this.applySelection();
  }

  applySelection() {
    const { posterOrientation } = this.state;
    this.querySelectorAll(".js-poster-orientation").forEach((el) => {
      el.classList.toggle(
        "active",
        String(el.dataset.posterOrientation) === String(posterOrientation),
      );
    });
  }

  applyAvailability() {
    const { printType } = this.state;
    const disabled = this.disabledByPrintType[printType] ?? [];

    this.querySelectorAll(".js-poster-orientation").forEach((el) => {
      const id = String(el.dataset.posterOrientation);
      const isDisabled = disabled.includes(id);
      el.classList.toggle("d-none", isDisabled);
    });
  }
  render() {
    this.innerHTML = /* html */ `
      <strong><small data-i18n="components.orientationSelector.title">Kies een oriëntatie</small></strong>
      <div class="d-flex flex-wrap gap-3 mb-3 mt-2">
          <div class="js-poster-orientation flex-shrink-0 selectable-card text-center p-1" style="flex-basis: ${cardWidth};"
              data-poster-orientation="portrait">
            <img
              src="${portraitImg}"
              class="img-fluid w-100 h-auto rounded"
            />
            <small data-i18n="components.orientationSelector.portrait">Staand</small>
          </div>
          <div class="js-poster-orientation flex-shrink-0 selectable-card text-center p-1" style="flex-basis: ${cardWidth};"
              data-poster-orientation="landscape">
            <img
              src="${landscapeImg}"
              class="img-fluid w-100 h-auto rounded"
            />
            <small data-i18n="components.orientationSelector.landscape">Liggend</small>
          </div>
      </div>
    `;
  }
}

customElements.define("orientation-selector", OrientationSelector);
